<template>
  <div class="mt-eidt-content">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "MtEditContent",
};
</script>


// WEBPACK FOOTER //
// src/components/Mt/MtEditContent/index.vue